import panelLayout from "./panelLayout"

export default  panelLayout;
